import React, { useState, useEffect } from 'react';
import * as Yup from "yup";
import BaseboardForm from './BaseboardForm'
import { Paper, withStyles, Dialog, CircularProgress } from "@material-ui/core";
import { BackButton, hasPermission, parseURL } from '../../sc-utilities';
import { connect } from "react-redux";
import * as actions from "./store/baseboardActions";
import History from "../../../History";
import AppLogoLoading from '../../sc-logo';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    },
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },

    cancel: {
        width: "250px",
        margin: "10px"
    }
});

const BaseboardEdit = props => {
    const { baseboard, loading, classes, onFetchBaseboardInit, activeCustomer, translations, permissions } = props;
    const [data, setData] = useState(true);
    let searchParams = parseURL(window.location.search);

    const handleSubmit = async data => {
        data['ComponentID'] = baseboard.ComponentID;
        data['ComponentType'] = 'baseboard';
        data['ProductID'] = searchParams.productID;

        let result = await props.onEditBaseboard({ ...data, ActiveCustomerID: activeCustomer });
        if (result) {
            History.goBack()
        }
    }
    useEffect(() => {
        const fetchData = async () => {
            await props.onFetchBaseboard({ ActiveCustomerID: activeCustomer, ComponentID: parseURL(window.location.href).ComponentID })
            setData(false)
        }
        fetchData();
        return () => {
            onFetchBaseboardInit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let initialValues = {
        ComponentType: "baseboard",
        Vendor: baseboard.Vendor || "",
        Version: baseboard && baseboard['BaseboardComponents'] && baseboard['BaseboardComponents'].length > 0 ? baseboard['BaseboardComponents'][0].Version : '',
        ComponentModel: baseboard.ComponentModel || '',
        SerialNumber: baseboard.SerialNumber || '',
        Description: baseboard.Description || ''
    };
    let formSettings = {
        Validation: {
            ComponentType: Yup.string().required("Required"),
            Vendor: Yup.string().required("Required"),
            Version: Yup.string().required("Required"),
            ComponentModel: Yup.string().required("Required"),
            SerialNumber: Yup.string().required("Required"),
        },
        FormTitle: translations['edit_baseboard_component'] || "Edit baseboard component",
        ButtonSubmit: searchParams.editable === '1' && hasPermission(permissions, "component_save")
            ? {
                Title: translations["save"] || "SAVE",
                Color: 'primary'
            }
            : null,
    };

    return (
        <Paper className={classes.root} >
            {BackButton(translations)}
            <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={data}
                PaperProps={{
                    classes: {
                        root: classes.submit
                    }
                }} >

                <AppLogoLoading />
            </Dialog>
            {!data ?
                <BaseboardForm
                    formSettings={formSettings}
                    initialValues={initialValues}
                    handleSubmit={handleSubmit}
                    loading={loading}
                    translations={translations}
                ></BaseboardForm>
                : <CircularProgress
                    variant="static"
                    color="primary"
                    size={28}
                />}
        </Paper>)
}

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        baseboard: state.product.baseboards.loaded ? state.product.baseboards.loaded : {},
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchBaseboardInit: baseboard => dispatch(actions.loadBaseboardInit(baseboard)),
        onFetchBaseboard: baseboard => dispatch(actions.loadBaseboard(baseboard)),
        onEditBaseboard: baseboard => dispatch(actions.editBaseboard(baseboard)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(BaseboardEdit));
